/**
 * @fileoverview Maps an agent category to the set of "Agent type" subtypes its
 * digest should expose in the Agent type filter.
 *
 * Today the Data and QA categories own a single subtype each, so their filter
 * shows a single locked option; adding a subtype to `categorySubtypes` makes the
 * filter offer a real choice without further wiring.
 *
 * The Canvas category deliberately returns no subtypes: it is the default
 * landing digest and shows neither the Agent type column nor filter.
 * @owner @Appboy/agent-console
 */

import { AGENT_CATEGORIES, visibleCategorySubtypes } from "./agentCategory";
import type { AgentCategory, SubtypeAvailability } from "./agentCategory";
import type { InteractionSite } from "./types";

/**
 * Returns the interaction-site subtypes the digest for `category` should offer
 * in its Agent type filter, or `undefined` when the digest should not render the
 * Agent type column/filter (i.e. Canvas). Feature-flagged subtypes that are not
 * yet enabled are filtered out via `availability`.
 */
export const agentTypeFilterSubtypesGetter = (
  category: AgentCategory | undefined,
  availability: SubtypeAvailability
): InteractionSite[] | undefined => {
  if (category === undefined || category === AGENT_CATEGORIES.CANVAS) {
    return undefined;
  }
  return visibleCategorySubtypes(category, availability);
};
